import TypeError from '.TypeError';
import RangeError from '.RangeError';
import WeakSet from '.WeakSet';
import WeakMap from '.WeakMap';
import set_has from '.WeakSet.prototype.has';
import set_add from '.WeakSet.prototype.add';
import set_del from '.WeakSet.prototype.delete';
import map_has from '.WeakMap.prototype.has';
import map_get from '.WeakMap.prototype.get';
import map_set from '.WeakMap.prototype.set';
import map_del from '.WeakMap.prototype.delete';
import isArray from '.Array.isArray';
import undefined from '.undefined';

const INLINES = new WeakMap                                                                     ();
const SECTIONS = new WeakSet                ();

const deInline = /*#__PURE__*/map_del.bind(INLINES)                                                                              ;
const deSection = /*#__PURE__*/set_del.bind(SECTIONS)                                                  ;

export const isInline = /*#__PURE__*/map_has.bind(INLINES)                                                  ;
export const ofInline = /*#__PURE__*/map_get.bind(INLINES)     
	                                                                          
	                                                               
	                                       
 ;
export const beInline = /*#__PURE__*/map_set.bind(INLINES)     
	                                                                                  
	                                                                       
 ;
export const inline =                                                         (value   , mode                , looping         )    => {
	if ( isArray(value) ) {
		if ( looping ) { mode = 3; }
		else {
			if ( mode===undefined ) { mode = 3; }
			else if ( mode!==0 && mode!==1 && mode!==2 && mode!==3 ) {
				throw typeof mode==='number'
					? RangeError(`array inline mode must be 0 | 1 | 2 | 3, not including ${mode}`)
					: TypeError(`array inline mode must be "number" type, not including ${mode===null ? '"null"' : typeof mode}`);
			}
		}
		beInline(value, mode);
	}
	else {
		beInline(value, true);
		deSection(value);
	}
	return value;
};
export const multilineTable =                                  (value   )    => {
	beInline(value, false);
	deSection(value);
	return value;
};
export const multilineArray =                                       (value   )    => {
	deInline(value);
	return value;
};

export const isSection = /*#__PURE__*/set_has.bind(SECTIONS)                                                                  ;
export const beSection = /*#__PURE__*/set_add.bind(SECTIONS)                                                 ;
export const Section =                            (table   )    => {
	if ( isArray(table) ) { throw TypeError(`array can not be section, maybe you want to use it on the tables in it`); }
	beSection(table);
	deInline(table);
	return table;
};

                                                       